import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';

@Component({
  selector: 'formly-field-spacer',
  template: `
    <div
      class="formly-spacer"
      [class.large]="props['label']?.toLowerCase() === 'large'"
      [class.medium]="props['label']?.toLowerCase() === 'medium'"
      [class.small]="props['label']?.toLowerCase() === 'small'"></div>
  `,
  styles: [
    `
      .formly-spacer.small {
        margin: 1rem 0;
      }
      .formly-spacer.medium {
        margin: 2.5rem 0;
      }
      .formly-spacer.large {
        margin: 5rem 0;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormlySpacerComponent extends FieldType {}
